import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ThumbsUp from './icon-thumbs-up.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ThumbsUp {...validProps} />;
}
SvgComponent.iconName = 'thumbs-up';

/**
 * @deprecated This is a legacy icon
 */
export const ThumbsUpIcon = svgIconWrapper(SvgComponent);
